var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.list.length))?_c('div',{staticClass:"guide-wrap"},[_vm._l(((_vm.list)),function(item,index){return [_c('div',{staticClass:"item"},[_c('mpx-image',{staticClass:"icon",attrs:{"src":(_vm.icon)}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item))])],1)]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }